import { createAsyncThunk } from "@reduxjs/toolkit";
import { IAPIResponse, IMasterTournament, ITournament } from "../../types/api";
import { alertActions } from "../alert/alertSlice";
import {
    getTournaments as getTournamentsFromAPI,
    getMasterTournaments as getMasterTournamentsFromAPI,
    getHomeLeagues as getHomeLeaguesFromAPI,
    updateHomeLeagues as updateHomeLeaguesFromAPI,
} from "../../lib/api";
import { IHomeLeague, IHomeLeaguesFormData } from "../../types/forms";

interface IGetTournamentsResponse extends IAPIResponse {
    tournaments: ITournament[];
}

interface IGetMasterTournamentsResponse extends IAPIResponse {
    tournaments: IMasterTournament[];
}

interface IGetHomeLeaguesResponse extends IAPIResponse {
    homeLeagues: IHomeLeague[];
}

export const getTournaments = createAsyncThunk<
    IGetTournamentsResponse,
    boolean | undefined,
    { rejectValue: string }
>(
    "tournamentmanagement/getTournaments",
    async (_, { rejectWithValue, dispatch }) => {
        try {
            const response = await getTournamentsFromAPI();

            return response;
        } catch (e) {
            const error = e as string;
            // dispatch(
            //     alertActions.error({
            //         level: "danger",
            //         text: "Team retrieval failed. Please try again later or contact an admin",
            //         title: error,
            //     }),
            // );
            return rejectWithValue(error);
        }
    },
);

export const getMasterTournaments = createAsyncThunk<
    IGetMasterTournamentsResponse,
    boolean | undefined,
    { rejectValue: string }
>(
    "tournamentmanagement/getMasterTournaments",
    async (_, { rejectWithValue, dispatch }) => {
        try {
            const response = await getMasterTournamentsFromAPI();

            return response;
        } catch (e) {
            const error = e as string;
            // dispatch(
            //     alertActions.error({
            //         level: "danger",
            //         text: "Team retrieval failed. Please try again later or contact an admin",
            //         title: error,
            //     }),
            // );
            return rejectWithValue(error);
        }
    },
);

export const getHomeLeagues = createAsyncThunk<
    IGetHomeLeaguesResponse,
    boolean | undefined,
    { rejectValue: string }
>(
    "tournamentmanagement/getHomeLeagues",
    async (_, { rejectWithValue, dispatch }) => {
        try {
            const response = await getHomeLeaguesFromAPI();

            return response;
        } catch (e) {
            const error = e as string;
            // dispatch(
            //     alertActions.error({
            //         level: "danger",
            //         text: "Team retrieval failed. Please try again later or contact an admin",
            //         title: error,
            //     }),
            // );
            return rejectWithValue(error);
        }
    },
);

export const updateHomeLeagues = createAsyncThunk<
    IHomeLeague[] | false,
    IHomeLeaguesFormData,
    { rejectValue: string }
>("global/updateHomeLeagues", async (notice, { rejectWithValue, dispatch }) => {
    try {
        const response = await updateHomeLeaguesFromAPI(notice);

        dispatch(
            alertActions.success({
                title: "Home Leagues updated successfully",
                dismissible: true,
            }),
        );

        return response.homeLeagues;
    } catch (e) {
        const error = e as string;

        dispatch(
            alertActions.error({
                title: "The server encountered a problem updating the site notice.",
                text: "If the problem continues, please reach out to an admin.",
                dismissible: true,
            }),
        );
        return rejectWithValue(error);
    }
});
